import { RevisionIssueScanState } from '../../../types';
import Icon, { icons } from '../Icon';
import getCommitStatus from './getCommitStatus';
import IssuePill from './IssuePill';
import COLORS from '../../../theme/colors';
import Pill from './Pill';

const STYLES_MAP = {
  [RevisionIssueScanState.IssuesFound]: {
    borderColor: COLORS.fossaRed,
    color: COLORS.fossaRed,
  },
  [RevisionIssueScanState.Passing]: {
    color: COLORS.fossaGreen,
  },
  [RevisionIssueScanState.NeedsConfiguration]: {
    color: '#ffce4d',
  },
};

const BuildPill = ({ project }) => {
  const latest = project?.revisions?.[0] ?? null;
  const status = getCommitStatus(latest);
  const defaultBranch = project.default_branch;
  const style = STYLES_MAP[status] || null;

  switch (status) {
    case RevisionIssueScanState.IssuesFound:
      return (
        <IssuePill
          defaultBranch={defaultBranch}
          licensingIssues={latest.unresolved_licensing_issue_count}
          securityIssues={latest.unresolved_security_issue_count}
          qualityIssues={latest.unresolved_quality_issue_count}
          unresolvedIssues={latest.unresolved_issue_count}
          style={style}
      />
      );
    case RevisionIssueScanState.Passing:
      return (
        <Pill defaultBranch={defaultBranch}>
          <span style={style}>
            <Icon icon={icons.circle} />
          </span>
          <span className="margin-left-xs">
            No Issues Found
          </span>
        </Pill>
      );
    case RevisionIssueScanState.NeedsConfiguration:
      return (
        <Pill defaultBranch={defaultBranch}>
          <Icon icon={icons.warning} />
          <span className="margin-left-xs">
            Needs Configuration
          </span>
        </Pill>
      );
    default:
      return (
        <Pill defaultBranch={defaultBranch}>
          <Icon icon={icons.circleO} hasSpin />
          <span className="margin-left-xs">
            Waiting to Scan...
          </span>
        </Pill>
      );
  }
};

export default BuildPill;
